import { Injectable } from "@angular/core";

import { AppConfig } from "environments/environment";

export const LOCAL_URI = "http://localhost:4200";
const DEV_URI = "https://vision-dev.inseer.com";
const STAGING_URI = "https://vision-staging.inseer.com";
const PROD_URI = "https://vision.inseer.com";

@Injectable({ providedIn: "root" })
export class EnvironmentUtilsService {
  public isLocalEnv(): boolean {
    return (
      location.hostname.toLowerCase().endsWith("localhost") ||
      location.hostname.endsWith("127.0.0.1") ||
      location.hostname === ""
    );
  }

  public isDev(): boolean {
    if (AppConfig.environment.toLowerCase().includes("dev")) {
      return true;
    }
    return false;
  }

  public isStaging(): boolean {
    if (AppConfig.environment.toLowerCase().includes("staging")) {
      return true;
    }
    return false;
  }

  public isProd(): boolean {
    return AppConfig.environment.toLowerCase().includes("prod");
  }

  public getBaseURI(): string {
    if (this.isLocalEnv()) return LOCAL_URI;
    else if (this.isDev()) return DEV_URI;
    else if (this.isStaging()) return STAGING_URI;
    else if (this.isProd()) return PROD_URI;
    return "";
  }
}
